import useId from '../utils/useId';
import * as React from 'react';
export const lovableSvg = React.forwardRef(function lovableSvgInner(
  props,
  ref,
) {
  const baseId = useId();
  const id_0 = baseId + '_0';
  const id_1 = baseId + '_1';
  const id_2 = baseId + '_2';
  const id_3 = baseId + '_3';
  const id_4 = baseId + '_4';
  const id_5 = baseId + '_5';
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F7F4ED',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement(
      'mask',
      {
        id: `bi_lovable__b_${id_0}`,
        style: {
          maskType: 'alpha',
        },
        maskUnits: 'userSpaceOnUse',
        x: 5,
        y: 3,
        width: 24,
        height: 25,
      },
      /*#__PURE__*/ React.createElement('path', {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M12.201 3a7.203 7.203 0 0 1 7.201 7.204v2.738H21.8a7.203 7.203 0 0 1 7.2 7.204 7.203 7.203 0 0 1-7.201 7.204H5V10.204A7.203 7.203 0 0 1 12.201 3Z',
        fill: `url(#bi_lovable__a_${id_1})`,
      }),
    ),
    /*#__PURE__*/ React.createElement(
      'g',
      {
        mask: `url(#bi_lovable__b_${id_0})`,
      },
      /*#__PURE__*/ React.createElement(
        'g',
        {
          filter: `url(#bi_lovable__c_${id_2})`,
        },
        /*#__PURE__*/ React.createElement('path', {
          d: 'M15.53 32.208c8.972 0 16.245-7.258 16.245-16.21 0-8.953-7.273-16.21-16.246-16.21-8.972 0-16.246 7.257-16.246 16.21 0 8.952 7.274 16.21 16.246 16.21Z',
          fill: '#4B73FF',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'g',
        {
          filter: `url(#bi_lovable__d_${id_3})`,
        },
        /*#__PURE__*/ React.createElement('path', {
          d: 'M17.313 23.312c11.491 0 20.807-7.257 20.807-16.21 0-8.952-9.316-16.21-20.807-16.21-11.491 0-20.807 7.258-20.807 16.21 0 8.953 9.316 16.21 20.807 16.21Z',
          fill: '#FF66F4',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'g',
        {
          filter: `url(#bi_lovable__e_${id_4})`,
        },
        /*#__PURE__*/ React.createElement('path', {
          d: 'M20.706 18.288c8.972 0 16.246-6.374 16.246-14.236 0-7.863-7.274-14.236-16.246-14.236-8.973 0-16.247 6.373-16.247 14.236 0 7.862 7.274 14.236 16.247 14.236Z',
          fill: '#FF0105',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'g',
        {
          filter: `url(#bi_lovable__f_${id_5})`,
        },
        /*#__PURE__*/ React.createElement('path', {
          d: 'M17.602 16.847c5.396 0 9.77-4.365 9.77-9.749s-4.374-9.748-9.77-9.748-9.77 4.364-9.77 9.748c0 5.384 4.374 9.749 9.77 9.749Z',
          fill: '#FE7B02',
        }),
      ),
    ),
    /*#__PURE__*/ React.createElement(
      'defs',
      null,
      /*#__PURE__*/ React.createElement(
        'filter',
        {
          id: `bi_lovable__c_${id_2}`,
          x: -7.982,
          y: -7.477,
          width: 47.022,
          height: 46.95,
          filterUnits: 'userSpaceOnUse',
          colorInterpolationFilters: 'sRGB',
        },
        /*#__PURE__*/ React.createElement('feFlood', {
          floodOpacity: 0,
          result: 'BackgroundImageFix',
        }),
        /*#__PURE__*/ React.createElement('feBlend', {
          in: 'SourceGraphic',
          in2: 'BackgroundImageFix',
          result: 'shape',
        }),
        /*#__PURE__*/ React.createElement('feGaussianBlur', {
          stdDeviation: 3.632,
          result: 'effect1_foregroundBlur_21264_24237',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'filter',
        {
          id: `bi_lovable__d_${id_3}`,
          x: -10.758,
          y: -16.373,
          width: 56.143,
          height: 46.95,
          filterUnits: 'userSpaceOnUse',
          colorInterpolationFilters: 'sRGB',
        },
        /*#__PURE__*/ React.createElement('feFlood', {
          floodOpacity: 0,
          result: 'BackgroundImageFix',
        }),
        /*#__PURE__*/ React.createElement('feBlend', {
          in: 'SourceGraphic',
          in2: 'BackgroundImageFix',
          result: 'shape',
        }),
        /*#__PURE__*/ React.createElement('feGaussianBlur', {
          stdDeviation: 3.632,
          result: 'effect1_foregroundBlur_21264_24237',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'filter',
        {
          id: `bi_lovable__e_${id_4}`,
          x: -2.805,
          y: -17.449,
          width: 47.022,
          height: 43.001,
          filterUnits: 'userSpaceOnUse',
          colorInterpolationFilters: 'sRGB',
        },
        /*#__PURE__*/ React.createElement('feFlood', {
          floodOpacity: 0,
          result: 'BackgroundImageFix',
        }),
        /*#__PURE__*/ React.createElement('feBlend', {
          in: 'SourceGraphic',
          in2: 'BackgroundImageFix',
          result: 'shape',
        }),
        /*#__PURE__*/ React.createElement('feGaussianBlur', {
          stdDeviation: 3.632,
          result: 'effect1_foregroundBlur_21264_24237',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'filter',
        {
          id: `bi_lovable__f_${id_5}`,
          x: 0.567,
          y: -9.915,
          width: 34.07,
          height: 34.027,
          filterUnits: 'userSpaceOnUse',
          colorInterpolationFilters: 'sRGB',
        },
        /*#__PURE__*/ React.createElement('feFlood', {
          floodOpacity: 0,
          result: 'BackgroundImageFix',
        }),
        /*#__PURE__*/ React.createElement('feBlend', {
          in: 'SourceGraphic',
          in2: 'BackgroundImageFix',
          result: 'shape',
        }),
        /*#__PURE__*/ React.createElement('feGaussianBlur', {
          stdDeviation: 3.632,
          result: 'effect1_foregroundBlur_21264_24237',
        }),
      ),
      /*#__PURE__*/ React.createElement(
        'linearGradient',
        {
          id: `bi_lovable__a_${id_1}`,
          x1: 13.076,
          y1: 7.279,
          x2: 20.36,
          y2: 27.352,
          gradientUnits: 'userSpaceOnUse',
        },
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.025,
          stopColor: '#FF8E63',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.56,
          stopColor: '#FF7EB0',
        }),
        /*#__PURE__*/ React.createElement('stop', {
          offset: 0.95,
          stopColor: '#4B73FF',
        }),
      ),
    ),
  );
});
lovableSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var lovable = {
  category: 'brand',
  colorable: false,
  name: 'lovable',
  svg: lovableSvg,
};
